import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import RichTextNotesHeader from './RichTextNotesHeader';
import { VerbRichTextEditor } from '../../../../../shared/components/formComponents/VerbRichTextEditor';

class FeedbackInviteSectionItem extends Component {
    static propTypes = {
        memberReference: PropTypes.string,
        isGlobalSectionItem: PropTypes.bool
    };

    render() {
        const { memberReference, isGlobalSectionItem } = this.props;
        return (
            <div className={'col-12'}>
                <RichTextNotesHeader isFeedback={true} />
                <Field
                    key={'description'}
                    name={memberReference ? `${memberReference}.content.description` : 'content.description'}
                    label={'Description'}
                    className={'col-12 description'}
                    placeholder={'Enter text'}
                    component={VerbRichTextEditor}
                    readOnly={isGlobalSectionItem}
                    rows={3}
                />
            </div>
        );
    }
}

export default FeedbackInviteSectionItem;
